export { gql } from '@apollo/client';

export type BffErrorResponse<T = undefined> = {
  code: string;
  data?: T;
};
